import { render, staticRenderFns } from "./BoatRealVideo.vue?vue&type=template&id=30619292&scoped=true&"
import script from "./BoatRealVideo.vue?vue&type=script&lang=js&"
export * from "./BoatRealVideo.vue?vue&type=script&lang=js&"
import style0 from "./BoatRealVideo.vue?vue&type=style&index=0&id=30619292&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30619292",
  null
  
)

export default component.exports